import { useQuery } from "@tanstack/react-query";
import React from "react";
import { API } from "../API";
import { VisitInstanceDetails, VisitInstanceDutySheet } from "../messages";
import { isDefined } from "./Generic/IsDefined";

interface Props {
  activeVisit: VisitInstanceDetails;
  api: API;
  children: (initialDutySheetData: VisitInstanceDutySheet) => React.ReactNode;
}

const WithDutySheet = (props: Props) => {
  const query = useQuery({
    queryKey: ["visit_instance", props.activeVisit.id],
    queryFn: () => props.api.getDutySheetByVisitInstanceId(props.activeVisit.id),
  });

  return <>{query.isLoading || !isDefined(query.data) ? null : props.children(query.data)}</>;
};

export default WithDutySheet;
